"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconQuestionCircle = function SvgIconQuestionCircle(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "question circle icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Question Circle Icon'), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "nonzero",
    d: "M44 24c0 11.048-8.955 20-20 20S4 35.048 4 24C4 12.958 12.955 4 24 4s20 8.958 20 20zM24.537 10.613c-4.395 0-7.198 1.851-9.4 5.142a.97.97 0 00.22 1.31l2.798 2.123a.967.967 0 001.344-.172c1.44-1.827 2.428-2.886 4.621-2.886 1.647 0 3.685 1.06 3.685 2.658 0 1.207-.997 1.827-2.623 2.74-1.897 1.063-4.408 2.387-4.408 5.698v.322c0 .535.433.968.968.968h4.516a.968.968 0 00.968-.968v-.107c0-2.295 6.708-2.391 6.708-8.602 0-4.678-4.852-8.226-9.397-8.226zm-.537 20a3.714 3.714 0 00-3.71 3.71 3.714 3.714 0 003.71 3.71 3.714 3.714 0 003.71-3.71 3.714 3.714 0 00-3.71-3.71z"
  }));
};

var _default = SvgIconQuestionCircle;
exports.default = _default;